import React, { useState, useEffect } from "react";
import {
  Heading,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Box,
  Button,
  Skeleton,
} from "@chakra-ui/react";
import ProductItem from "./ProductItem";
import useFetch from "../../../../hooks/useFetch";

const ProductList = ({
  userId,
  priceListId,
  setCustomPriceList,
  setIsEdited,
}) => {
  const [showNewProduct, setShowNewProduct] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [userPriceList, setUserPriceList] = useState([]);
  const [priceList, setPriceList] = useState([]);
  const { get } = useFetch();

  const setInitialData = async () => {
    let customPriceList = await get(`/users/${userId}/admin/price-lists`);
    setUserPriceList(customPriceList);
    setCustomPriceList(customPriceList);
    setPriceList(await get(`/users/price-lists/${priceListId}`));
    setIsLoading(false);
  };

  useEffect(() => {
    setInitialData();
  }, []);

  const editUserProducts = (product, action) => {
    let newUserPriceList = [...userPriceList];
    switch (action) {
      case "new":
        newUserPriceList = [product, ...newUserPriceList];
        break;
      case "remove":
        newUserPriceList = newUserPriceList.filter(
          (prod) => prod.id !== product.id
        );
        break;
      case "edit":
        let index = newUserPriceList.findIndex((p) => p.id == product.id);
        if (index >= 0) newUserPriceList[index] = product;
        break;
    }
    setCustomPriceList(newUserPriceList);
    setUserPriceList(newUserPriceList);
  };

  return (
    <>
      <Heading variant="h2">Artículos</Heading>
      <Button
        my="2"
        colorScheme="blue"
        onClick={() => setShowNewProduct(true)}
        isDisabled={showNewProduct}
      >
        + Artículo
      </Button>

      {isLoading ? (
        <Skeleton height="200px" mx="1rem" />
      ) : (
        <Box overflowX={"scroll"} pb={"0.5rem"}>
          <Table variant="striped" colorScheme="gray" fontSize="0.8em" w="100%">
            <Thead>
              <Tr>
                <Th fontSize="0.8em">Artículo</Th>
                <Th fontSize="0.8em">Costo ($)</Th>
                <Th fontSize="0.8em" title="Ganancia">
                  Gan. (%)
                </Th>
                <Th fontSize="0.8em">Precio con ganancia ($)</Th>
                <Th fontSize="0.8em" title="Descuento">
                  Desc. (%)
                </Th>
                <Th fontSize="0.8em">Precio con descuento ($)</Th>
                <Th fontSize="0.8em">Activo</Th>
                <Th fontSize="0.8em" title="Modificado">
                  Mod.
                </Th>
                <Th fontSize="0.8em" textAlign="center">
                  Acciones
                </Th>
              </Tr>
            </Thead>
            <Tbody>
              {showNewProduct && (
                <ProductItem
                  product={{}}
                  setShowNewProduct={setShowNewProduct}
                  updateProducts={editUserProducts}
                  initialAction="new"
                  userPriceList={userPriceList}
                  priceList={priceList}
                  setIsEdited={setIsEdited}
                />
              )}
              {userPriceList.map((product) => (
                <ProductItem
                  key={product.id}
                  product={product}
                  setShowNewProduct={setShowNewProduct}
                  updateProducts={editUserProducts}
                  userPriceList={userPriceList}
                  priceList={priceList}
                  setIsEdited={setIsEdited}
                />
              ))}
            </Tbody>
          </Table>
        </Box>
      )}
    </>
  );
};

export default ProductList;
